import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Fetch delivery drivers
export const fetchDeliveryDrivers = createAsyncThunk(
  "delivery/fetchDeliveryDrivers",
  async (page = 1, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.get(
        `${BASE_URL}/dashboard/delivery?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Error fetching delivery drivers"
      );
    }
  }
);

// Fetch single delivery driver with orders
export const fetchDeliveryDriver = createAsyncThunk(
  "delivery/fetchDeliveryDriver",
  async (id, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.get(
        `${BASE_URL}/dashboard/delivery/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Error fetching delivery driver"
      );
    }
  }
);

// Add new delivery driver
export const addDeliveryDriver = createAsyncThunk(
  "delivery/addDeliveryDriver",
  async (driverData, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const formData = new FormData();
      formData.append("name", driverData.name);
      formData.append("email", driverData.email);
      formData.append("phone", driverData.phone);
      formData.append("password", driverData.password);
      formData.append("password_confirmation", driverData.password_confirmation);
      formData.append("type_motorcycles", driverData.type_motorcycles);
      formData.append("lat", driverData.lat || "");
      formData.append("lng", driverData.lng || "");
      formData.append("address", driverData.address || "");
      formData.append("fcm_token", driverData.fcm_token || "random_id_" + Date.now());
      formData.append("is_active", driverData.is_active);
      formData.append("status", driverData.status);
      
      if (driverData.vehicle_license) {
        formData.append("vehicle_license", driverData.vehicle_license);
      }
      if (driverData.driving_license) {
        formData.append("driving_license", driverData.driving_license);
      }
      if (driverData.id_card) {
        formData.append("id_card", driverData.id_card);
      }
      if (driverData.image) {
        formData.append("image", driverData.image);
      }

      const response = await axios.post(
        `${BASE_URL}/dashboard/delivery`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Error adding delivery driver"
      );
    }
  }
);

// Update delivery driver
export const updateDeliveryDriver = createAsyncThunk(
  "delivery/updateDeliveryDriver",
  async ({ id, driverData }, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const formData = new FormData();
      formData.append("name", driverData.name);
      formData.append("email", driverData.email);
      formData.append("phone", driverData.phone);
      if (driverData.password) {
        formData.append("password", driverData.password);
      }
      if (driverData.password_confirmation) {
        formData.append("password_confirmation", driverData.password_confirmation);
      }
      formData.append("type_motorcycles", driverData.type_motorcycles);
      formData.append("lat", driverData.lat || "");
      formData.append("lng", driverData.lng || "");
      formData.append("address", driverData.address || "");
      formData.append("is_active", driverData.is_active);
      formData.append("status", driverData.status);
      
      if (driverData.vehicle_license) {
        formData.append("vehicle_license", driverData.vehicle_license);
      }
      if (driverData.driving_license) {
        formData.append("driving_license", driverData.driving_license);
      }
      if (driverData.id_card) {
        formData.append("id_card", driverData.id_card);
      }
      if (driverData.image) {
        formData.append("image", driverData.image);
      }

      const response = await axios.post(
        `${BASE_URL}/dashboard/delivery/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Error updating delivery driver"
      );
    }
  }
);

// Delete delivery driver
export const deleteDeliveryDriver = createAsyncThunk(
  "delivery/deleteDeliveryDriver",
  async (id, { rejectWithValue }) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.delete(
        `${BASE_URL}/dashboard/delivery/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          }
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete delivery driver"
      );
    }
  }
);

// Toggle driver status
export const toggleDriverStatus = createAsyncThunk(
  "delivery/toggleDriverStatus",
  async ({ id, is_active }, { rejectWithValue }) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.post(
        `${BASE_URL}/dashboard/delivery/${id}`,
        { is_active },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      return { id, is_active, response: response.data };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "فشل في تغيير حالة السائق"
      );
    }
  }
);

const deliverySlice = createSlice({
  name: "delivery",
  initialState: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
    addLoading: false,
    addError: null,
    addSuccessMessage: null,
    updateSuccess: null,
    statusToggleLoading: false,
    statusToggleError: null,
    currentDriver: null,
    currentDriverLoading: false,
    currentDriverError: null
  },
  reducers: {
    clearDeliveryState: (state) => {
      state.error = null;
      state.addError = null;
      state.addSuccessMessage = null;
      state.updateSuccess = null;
      state.statusToggleError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch delivery drivers
      .addCase(fetchDeliveryDrivers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeliveryDrivers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchDeliveryDrivers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add delivery driver
      .addCase(addDeliveryDriver.pending, (state) => {
        state.addLoading = true;
        state.addError = null;
        state.addSuccessMessage = null;
      })
      .addCase(addDeliveryDriver.fulfilled, (state, action) => {
        state.addLoading = false;
        state.addSuccessMessage = action.payload.message || "تم إضافة السائق بنجاح";
      })
      .addCase(addDeliveryDriver.rejected, (state, action) => {
        state.addLoading = false;
        state.addError = action.payload;
      })
      // Update delivery driver
      .addCase(updateDeliveryDriver.fulfilled, (state) => {
        state.updateSuccess = true;
      })
      .addCase(updateDeliveryDriver.rejected, (state, action) => {
        state.error = action.payload;
      })
      // Delete delivery driver
      .addCase(deleteDeliveryDriver.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDeliveryDriver.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.data = state.data.filter((item) => item.id !== action.payload);
      })
      .addCase(deleteDeliveryDriver.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Toggle driver status
      .addCase(toggleDriverStatus.pending, (state) => {
        state.statusToggleLoading = true;
        state.statusToggleError = null;
      })
      .addCase(toggleDriverStatus.fulfilled, (state, action) => {
        state.statusToggleLoading = false;
        state.statusToggleError = null;
        // Update the driver status in the data array
        const driverIndex = state.data.findIndex(driver => driver.id === action.payload.id);
        if (driverIndex !== -1) {
          state.data[driverIndex].is_active = action.payload.is_active;
        }
      })
      .addCase(toggleDriverStatus.rejected, (state, action) => {
        state.statusToggleLoading = false;
        state.statusToggleError = action.payload;
      })
      // Fetch single delivery driver
      .addCase(fetchDeliveryDriver.pending, (state) => {
        state.currentDriverLoading = true;
        state.currentDriverError = null;
      })
      .addCase(fetchDeliveryDriver.fulfilled, (state, action) => {
        state.currentDriverLoading = false;
        state.currentDriver = action.payload.data;
        state.currentDriverError = null;
      })
      .addCase(fetchDeliveryDriver.rejected, (state, action) => {
        state.currentDriverLoading = false;
        state.currentDriverError = action.payload;
      });
  },
});

export const { clearDeliveryState } = deliverySlice.actions;
export default deliverySlice.reducer;
